/*
 * @Author: heshouzhi heshouzhi@millionlab.cn
 * @Date: 2024-05-10 16:28:03
 * @LastEditors: heshouzhi heshouzhi@millionlab.cn
 * @LastEditTime: 2024-05-11 14:33:45
 * @FilePath: /web-crm/src/pages/gift/gift_data/services/giftData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';
//活动分页
export function queryEventPage(values) {
  return request('/activityStoreCard/queryCardOrderPage', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activity/deleteEvent', {
    method: 'POST',
    data: values,
  });
}
